import React from "react";

const servicesData = [


  // NEW SERVICES

  {
    img: "/images/services/1.jpg",
    title: "Urbania Airport Transfer Service ",
    text:
      "Book Urbania for airport transfers with spacious seating and luggage capacity. Ideal for group airport pickups and drops with timely and hassle-free service.",
    link: "/urbania-airport-transfer",
  },
  {
    img: "/images/services/2.jpg",
    title: "Urbania Outstation Travel Service ",
    text:
      "Plan your outstation trips with Urbania van rental. Enjoy long-distance travel with comfort, safety, and experienced drivers for a smooth journey.",
    link: "/urbania-outstation-travel",
  },
  {
    img: "/images/services/3.jpg",
    title: "Urbania Local City Tours ",
    text:
      "Explore the city with Urbania local ride services. Perfect for sightseeing, family outings, and group travel within the city limits.",
    link: "/urbania-local-city-tour",
  },
  {
    img: "/images/services/4.jpg",
    title: "Urbania Corporate Travel Service ",
    text:
      "Urbania corporate travel service is designed for office staff transport, meetings, and business events with reliable and professional service.",
    link: "/urbania-corporate-travel",
  },
  {
    img: "/images/services/5.jpg",
    title: "Urbania One-Way & Round Trip Service ",
    text:
      "Choose Urbania for one-way drops or round trips. Flexible travel options for group journeys with transparent pricing and comfortable rides.",
    link: "/urbania-oneway-roundtrip",
  },
  {
    img: "/images/services/6.jpg",
    title: "Urbania Wedding & Event Transport ",
    text:
      "Make your special events memorable with Urbania rental for weddings, festivals, and group functions. Travel together in comfort and style.",
    link: "/urbania-wedding-event-transport",
  },
  {
    img: "/images/services/7.jpg",
    title: "Urbania Luxury Travel Service ",
    text:
      "Experience premium group travel with luxury Urbania vans featuring pushback seats, AC, and modern interiors for a superior travel experience.",
    link: "/urbania-luxury-travel",
  },
  {
    img: "/images/services/8.jpg",
    title: "Urbania Festival & Event Rides ",
    text:
      "Book Urbania for festival trips and special events. Ideal for group celebrations, religious tours, and seasonal travel with comfort and safety.",
    link: "/urbania-festival-rides",
  },
  {
    img: "/images/services/9.jpg",
    title: "Urbania Business Travel Service ",
    text:
      "Urbania business travel service offers reliable transport for executives, team travel, and corporate meetings with punctual and professional drivers.",
    link: "/urbania-business-travel",
  },
    {
    img: "/images/keyword/2.jpg",
    title: "Urbania on Rent in Pimpri Chinchwad",
    text:
      "Looking for Urbania on rent in Pimpri Chinchwad? We provide premium Urbania vans for family outings, office travel, events, and long-distance journeys with experienced drivers.",
    link: "/urbania-on-rent-in-pimpri-chinchwad",
  },
  {
    img: "/images/keyword/1.jpg",
    title: "Urbania On Rent in Pune",
    text:
      "Hire Urbania on rent in Pune for weddings, corporate trips, tours, and outstation travel. Our well-maintained Urbania vans ensure comfort, safety, and a smooth travel experience at affordable prices.",
    link: "/urbania-on-rent-pune",
  },

{
  img: "/images/keyword/49.jpg",
  title: "Pune to Mumbai Urbania On Rent ",
  text:
    "Book Urbania on rent from Pune to Mumbai for comfortable and hassle-free group travel. Perfect for corporate trips, family journeys, and airport transfers with spacious seating, professional drivers, and reliable service.",
  link: "/pune-to-mumbai-urbania-on-rent",
},
];


const Services = () => {
  return (
    <>
      {/* Breadcrumb */}
      <div
        className="breadcumb-wrapper"
        data-overlay="black"
        data-opacity="3"
      >
        <div className="container">
          <div className="breadcumb-content text-center">
            <h1 className="breadcumb-title">Services</h1>
          </div>
        </div>
      </div>

      {/* Services Section */}
      <section className="overflow-hidden " id="service-sec">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-7">
              <div className="title-area text-center"></div>
            </div>
          </div>

          <div className="row gy-40 justify-content-center ">
            {servicesData.map((service, index) => (
              <div className="col-xl-4 col-md-6 py-3" key={index}>
                <div className="service-card borderr">
                  <div className="box-thumb">
                    <img src={service.img} alt={service.title} />
                  </div>

                  <div className="box-content">
                    <h3 className="box-title darkcolorrr">
                      <a >{service.title}</a>
                    </h3>
                    <p className="box-text">{service.text}</p>
                  </div>

                  <a href={service.link} className="th-btnn sm style33 borderrr ">
                    {/* Read More <i className="fas fa-arrow-up-right"></i> */}
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;
